export default __webpack_public_path__ + "static/media/crm.a7abf556.png";